import React from "react";
var __jsx = React.createElement;
import stl from "./CostumeCheckBox.module.css";
var CostumeCheckBox = function CostumeCheckBox(_ref) {
  var name = _ref.name,
    label = _ref.label,
    className = _ref.className,
    checked = _ref.checked,
    onChange = _ref.onChange,
    src = _ref.src,
    value = _ref.value,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("label", {
    className: "".concat(stl.wrapper, " ").concat(className ? className : "", " ").concat(checked ? stl.checked : "", " ")
  }, /*#__PURE__*/React.createElement("input", {
    name: name,
    type: "checkbox",
    onChange: onChange,
    checked: checked,
    value: value,
    disabled: disabled
  }), src && checked && /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "whatsapp"
  }), /*#__PURE__*/React.createElement("span", null), label);
};
export default CostumeCheckBox;